import { render, staticRenderFns } from "./CategoryNavigation.vue?vue&type=template&id=866c50da&scoped=true&"
import script from "./CategoryNavigation.vue?vue&type=script&lang=js&"
export * from "./CategoryNavigation.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNavigation.vue?vue&type=style&index=0&id=866c50da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866c50da",
  null
  
)

export default component.exports